"use client"
import { Card } from "@mui/material"
import { styled } from "@mui/material/styles"
import { Colors } from "../Theme/colors"

export const StyledTableCard = styled(Card)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignSelf: "stretch",
  gap: 12,
  padding: 16,
  background: "#FFFFFF 0% 0% no-repeat padding-box",
  borderRadius: 12,
  border: `1px solid ${Colors.secondaryLight}`,
  boxShadow: "none",
})
